<template>
  <el-dialog
    :title="titlebt"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-steps :active="active">
      <el-step title="填写经营信息" icon="el-icon-edit"></el-step>
      <el-step title="填写商户信息" icon="el-icon-edit"></el-step>
      <el-step title="填写结算账户" icon="el-icon-edit"></el-step>
      <el-step title="填写组织机构信息" icon="el-icon-edit"></el-step>
      <el-step title="确认提交" icon="el-icon-upload"></el-step>
    </el-steps>
    <div  v-if="typeone">
    <el-form ref="form" :model="form" label-width="120px"  style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
      <el-form-item label="联系信息" class="grid-content bg-purple-dark">
      </el-form-item>

      <el-form-item label="联系人姓名" prop="legal"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.legal"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="mobileNo"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.mobileNo"></el-input>
      </el-form-item>
      <el-form-item label="常用邮箱" prop="email"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.email"></el-input>
      </el-form-item>
    </el-form>
    <el-form ref="form2" :model="form2" label-width="140px"  style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
      <el-form-item label="经营信息" class="grid-content bg-purple-dark">
      </el-form-item>

      <el-form-item label="商户简称" prop="shortername"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form2.shortername"></el-input>
      </el-form-item>
      <el-form-item
              prop="one_type"
              label="经营类别"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form2.one_type"
                placeholder="请选择一级经营类别"
                @change="currentTypeSel(form2.one_type)"
        >
          <el-option
                  v-for="item in shopOptions"
                  :key="item.typeid"
                  :label="item.typename"
                  :value="item.typeid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="two_type"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form2.two_type"
                placeholder="请选择二级经营类别"
                @change="currentTypeSel2(form2.two_type)"
        >
          <el-option
                  v-for="item in shopOptions2"
                  :key="item.typeid"
                  :label="item.typename"
                  :value="item.typeid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="three_type"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form2.three_type"
                placeholder="请选择三级经营类别"
        >
          <el-option
                  v-for="item in shopOptions3"
                  :key="item.typeid"
                  :label="item.typename"
                  :value="item.typeid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商户名称" prop="agentname"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form2.agentname"></el-input>
      </el-form-item>
      <el-form-item label="注册地址" prop="compaddress"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form2.compaddress"></el-input>
      </el-form-item>
      <el-form-item label="售卖商品场景" prop="shop_scene"  :rules="[{ required: true, message: '不能为空'}]">

        <el-checkbox-group v-model="form2.shop_scene">
          <el-checkbox label="线下" disabled></el-checkbox>
          <el-checkbox label="公众号"></el-checkbox>
          <el-checkbox label="小程序"></el-checkbox>
          <el-checkbox label="网站"></el-checkbox>
          <el-checkbox label="APP"></el-checkbox>
        </el-checkbox-group>
<!--
        <el-checkbox-group v-model="form2.shop_scene">
          <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
        </el-checkbox-group>
-->
      </el-form-item>
      <el-form-item label="客服电话" prop="shop_tel"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form2.shop_tel"></el-input>
      </el-form-item>
      <el-form-item label="特殊资质" prop="special_qualification"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form2.special_qualification" style="display:none" ></el-input>
          <el-upload
                  ref="upload"
                  :action="imgUrl"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :limit=1
                  :auto-upload="true"
                  :file-list="fileList"
                  :before-upload="handleBeforeUpload"
                  :on-remove="handleRemove5"
                  :on-success="handlePictureCardPreview5">
              <i class="el-icon-plus"></i>
          </el-upload>
      </el-form-item>
      <el-form-item label="补充材料" prop="supple_materials"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form2.supple_materials" style="display:none" ></el-input>
          <el-upload
                  ref="upload"
                  :action="imgUrl"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :limit=1
                  :auto-upload="true"
                  :file-list="fileList2"
                  :before-upload="handleBeforeUpload"
                  :on-remove="handleRemove6"
                  :on-success="handlePictureCardPreview6">
              <i class="el-icon-plus"></i>
          </el-upload>
      </el-form-item>
    </el-form>
    </div>
    <div  v-if="typetwo">
      <el-form ref="form3" :model="form3" label-width="140px"  style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
        <el-form-item label="经营信息" class="grid-content bg-purple-dark">

        </el-form-item>
        <el-form-item label="营业执照注册号" prop="business_number"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form3.business_number"></el-input>
        </el-form-item>
        <el-form-item label="经营范围" prop="business_scope"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form3.business_scope"></el-input>
        </el-form-item>
        <el-form-item label="营业期限" prop="contractstdate"  :rules="[{ required: true, message: '不能为空'}]">
          <el-date-picker
                  v-model="form3.contractstdate"
                  type="date"
                  :picker-options="pickerOptions" value-format="yyyy-MM-dd">
          </el-date-picker>至 <el-date-picker
                v-model="form3.contractendate"
                type="date"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd">
        </el-date-picker>
        </el-form-item>
        <el-form-item label="营业执照照片" prop="business_img"  :rules="[{ required: true, message: '不能为空'}]">
            <el-input v-model="form3.business_img" style="display:none" ></el-input>
          <el-upload
                  ref="upload"
                  :action="imgUrl"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :limit=1
                  :auto-upload="true"
                  :file-list="fileList3"
                  :before-upload="handleBeforeUpload"
                  :on-remove="handleRemove"
                  :on-success="handlePictureCardPreview">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="营业执照注册名称" prop="business_license"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form3.business_license"></el-input>
        </el-form-item>


        <el-form-item
                prop="prov_cd"
                label="经营地址"
                :rules="[{ required: true, message: '不能为空'}]"
        >
          <el-select
                  class="filter-item"
                  v-model="form3.prov_cd"
                  placeholder="请选择省"
                  @change="currentSel(form3.prov_cd)"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.areaid"
                    :label="item.areaname"
                    :value="item.areaid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
                prop="city"
                label="市"
        >
          <el-select
                  class="filter-item"
                  v-model="form3.city"
                  placeholder="请选择市"
                  @change="currentSel2(form3.city)"
          >
            <el-option
                    v-for="item in typeOptions2"
                    :key="item.areaid"
                    :label="item.areaname"
                    :value="item.areaid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
                prop="areaid"
                label="区"
        >
          <el-select
                  class="filter-item"
                  v-model="form3.areaid"
                  placeholder="请选择区"
          >
            <el-option
                    v-for="item in typeOptions3"
                    :key="item.areaid"
                    :label="item.areaname"
                    :value="item.areaid"
            ></el-option>
          </el-select>
        </el-form-item>




      </el-form>
      <el-form ref="searchForm" :model="searchForm" label-width="140px"  style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
        <el-form-item label="企业法人/经办人" class="grid-content bg-purple-dark">

        </el-form-item>
        <el-form-item label="证件持有人类型" prop="holder_type"  :rules="[{ required: true, message: '不能为空'}]">
          <el-select
                  class="filter-item"
                  v-model="searchForm.holder_type"
                  placeholder="类型"
                  width="50"
          >
            <el-option
                    v-for="item in zjOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件持有人姓名" prop="holder_name"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="searchForm.holder_name"></el-input>
        </el-form-item>
        <el-form-item label="证件类型" prop="document_type"  :rules="[{ required: true, message: '不能为空'}]">
            <el-select
                    class="filter-item"
                    v-model="searchForm.document_type"
                    placeholder="证件类型"
                    width="50"
            >
                <el-option
                        v-for="item in zjlxOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="证件号码" prop="identification_number"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="searchForm.identification_number"></el-input>
        </el-form-item>
        <el-form-item label="证件有效期" prop="identification_start"  :rules="[{ required: true, message: '不能为空'}]">
            <el-date-picker
                    v-model="searchForm.identification_start"
                    type="date"
                    :picker-options="pickerOptions" value-format="yyyy-MM-dd">
            </el-date-picker>至 <el-date-picker
                v-model="searchForm.identification_end"
                type="date"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd">
        </el-date-picker>
        </el-form-item>
        <el-form-item label="证件扫描件" prop="idcards_front"  :rules="[{ required: true, message: '不能为空'}]">
            <el-input v-model="searchForm.idcards_front" style="display:none" ></el-input>
          <el-upload
                  ref="upload"
                  :action="imgUrl"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :limit=1
                  :auto-upload="true"
                  :file-list="fileList4"
                  :before-upload="handleBeforeUpload"
                  :on-remove="handleRemove2"
                  :on-success="handlePictureCardPreview2">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="证件扫描件反面" prop="idcards_back"  :rules="[{ required: true, message: '不能为空'}]">
            <el-input v-model="searchForm.idcards_back" style="display:none" ></el-input>
          <el-upload
                  ref="upload"
                  :action="imgUrl"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :limit=1
                  :auto-upload="true"
                  :file-list="fileList5"
                  :before-upload="handleBeforeUpload"
                  :on-remove="handleRemove3"
                  :on-success="handlePictureCardPreview3">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="是否开通电子发票" prop="electronic_invoice"  :rules="[{ required: true, message: '不能为空'}]">
            <el-radio v-model="searchForm.electronic_invoice" label="否">否</el-radio>
            <el-radio v-model="searchForm.electronic_invoice" label="是">是</el-radio>
        </el-form-item>
      </el-form>
    </div>
      <div  v-if="typethree">
        <el-form ref="form4" :model="form4" label-width="140px"  style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
          <el-form-item label="结算信息" class="grid-content bg-purple-dark">
          </el-form-item>
            <el-form-item label="微信费率" prop="wx_num_gf"  :rules="[{ required: true, message: '不能为空'}]">
                <el-input-number v-model="form4.wx_num_gf" :min="0.00" :max="100" :step="0.01"></el-input-number>
            </el-form-item>
            <el-form-item label="支付宝费率" prop="zfb_num_gf"  :rules="[{ required: true, message: '不能为空'}]">
                <el-input-number v-model="form4.zfb_num_gf" :min="0.00" :max="100" :step="0.01"></el-input-number>
            </el-form-item>
            <el-form-item label="随行付支付宝费率" prop="zfb_num_sxf" >
                <el-input-number v-model="form4.zfb_num_sxf" :min="0.00" :max="100" :step="0.01"></el-input-number>
            </el-form-item>
            <el-form-item label="随行付微信费率" prop="wx_num_sxf" >
                <el-input-number v-model="form4.wx_num_sxf" :min="0.00" :max="100" :step="0.01"></el-input-number>
            </el-form-item>
            <el-form-item label="乐刷支付宝费率" prop="zfb_num_fy" >
                <el-input-number v-model="form4.zfb_num_fy" :min="0.00" :max="100" :step="0.01"></el-input-number>
            </el-form-item>
            <el-form-item label="乐刷微信费率" prop="wx_num_fy" >
                <el-input-number v-model="form4.wx_num_fy" :min="0.00" :max="100" :step="0.01"></el-input-number>
            </el-form-item>
            <el-form-item label="账户类型" prop="zflxtype"  :rules="[{ required: true, message: '不能为空'}]">
                <el-select
                        class="filter-item"
                        v-model="form4.zflxtype"
                        placeholder="账户类型"
                        width="50"
                >
                    <el-option
                            v-for="item in zflxOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开户名称" prop="account_name"  :rules="[{ required: true, message: '不能为空'}]">
              <el-input v-model="form4.account_name"></el-input>
            </el-form-item>
            <el-form-item label="开户银行城市" prop="account_city"  :rules="[{ required: true, message: '不能为空'}]">
              <el-input v-model="form4.account_city"></el-input>
            </el-form-item>
            <el-form-item label="开户银行" prop="deposit_bank"  :rules="[{ required: true, message: '不能为空'}]">
              <el-select
                      class="filter-item"
                      v-model="form4.deposit_bank"
                      placeholder="开户银行"
                      width="50"
              >
                <el-option
                        v-for="item in kfyhOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                ></el-option>
              </el-select>

            </el-form-item>
            <el-form-item label="开户支行" prop="bank_branch"  :rules="[{ required: true, message: '不能为空'}]">
              <el-input v-model="form4.bank_branch"></el-input><span style='color: red;'>选择其他银行请务必填写全称、如"深圳农村商业银行XXX支行"</span>
            </el-form-item>
            <el-form-item label="银行账号" prop="bank_account"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form4.bank_account"></el-input>
        </el-form-item>
          <el-form-item label="开户许可证" prop="industry_license"  :rules="[{ required: true, message: '不能为空'}]">
            <el-input v-model="form4.industry_license" style="display:none" ></el-input>
              <el-upload
                      ref="upload"
                      :action="imgUrl"
                      accept="image/png,image/gif,image/jpg,image/jpeg"
                      list-type="picture-card"
                      :limit=1
                      :auto-upload="true"
                      :file-list="fileList6"
                      :before-upload="handleBeforeUpload"
                      :on-remove="handleRemove7"
                      :on-success="handlePictureCardPreview7">
                  <i class="el-icon-plus"></i>
              </el-upload>
          </el-form-item>

        </el-form>

    </div>
    <div  v-if="typefour">
      <el-form ref="form5" :model="form5" label-width="140px"  style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
        <el-form-item label="组织机构信息" class="grid-content bg-purple-dark">
        </el-form-item>
        <el-form-item label="组织机构代码" prop="organization_code" >
          <el-input v-model="form5.organization_code"></el-input>
        </el-form-item>
        <el-form-item label="组织机构有效期" prop="organization_start" >
            <el-date-picker
                    v-model="form5.organization_start"
                    type="date"
                    :picker-options="pickerOptions" value-format="yyyy-MM-dd">
            </el-date-picker>至 <el-date-picker
                v-model="form5.organization_end"
                type="date"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd">
        </el-date-picker>
        </el-form-item>
        <el-form-item label="组织机构代码证照片" prop="organization_img" >
          <el-input v-model="form5.organization_img" style="display:none" ></el-input>
          <el-upload
                  ref="upload"
                  :action="imgUrl"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :limit=1
                  :auto-upload="true"
                  :file-list="fileList7"
                  :before-upload="handleBeforeUpload"
                  :on-remove="handleRemove4"
                  :on-success="handlePictureCardPreview4">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <el-button  v-if="isup"
            type="primary"
            :loading="loading"
            @click="upp"
    >上一步</el-button>
    <el-button  v-if="xyb"
            type="primary"
            :loading="loading"
            @click="next"
    >下一步</el-button>
    <el-button  v-if="tj"
            type="primary"
            :loading="loading"
            @click="del()"
    >提交</el-button>
  </el-dialog>


</template>
<style>
  .customWidth{
    width:80%;
    height: 80%;
  }
  .bg-purple-dark {
    background: #e5e9f2;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js'
    const cityOptions = ['线下', '公众号', '小程序', '网站', 'APP'];
export default {
  name: "oldpartsEditForm",
    components:{
    },
  props: {
      agent: Object,
    value: Boolean
  },
  data() {
    return {
        imgUrl: process.env.VUE_APP_API+"/moblieapp/currencyUpload",
        cities: cityOptions,
        fileList: [],
        fileList2: [],
        fileList3: [],
        fileList4: [],
        fileList5: [],
        fileList6: [],
        fileList7: [],
        oneagent: Object,
        loading: false,
        dialogVisible: false,
        isup:false,
        xyb:true,
        active: 0,
        typeone: true,
        typetwo: false,
        typethree:false,
        typefour:false,
        titlebt:"",
        tj:false,
        pickerOptions: {}, // 日期设置对象
        typeOptions: [],
        typeOptions2: [],
        typeOptions3: [],
        shopOptions: [],
        shopOptions2: [],
        shopOptions3: [],
        form: {
            legal:"",
            mobileNo:"",
            email:""
        },
        form2: {
            shop_scene: ["线下"],
            special_qualification: '',
            supple_materials: '',
            shortername: '',
            agentname: '',
            compaddress: '',
            shop_tel: '',
            one_type: '',
            two_type: '',
            three_type: ''
        },
        kfyhOptions: [
          {
              value: "工商银行",
              label: "工商银行"
          },
          {
              value: "交通银行",
              label: "交通银行"
          },
          {
              value: "招商银行",
              label: "招商银行"
          },
          {
              value: "民生银行",
              label: "民生银行"
          },
          {
              value: "中信银行",
              label: "中信银行"
          },
          {
              value: "浦发银行",
              label: "浦发银行"
          },
          {
              value: "兴业银行",
              label: "兴业银行"
          },
          {
              value: "光大银行",
              label: "光大银行"
          },
          {
              value: "广发银行",
              label: "广发银行"
          },
          {
              value: "平安银行",
              label: "平安银行"
          },
          {
              value: "北京银行",
              label: "北京银行"
          },
          {
              value: "华夏银行",
              label: "华夏银行"
          },
          {
              value: "建设银行",
              label: "建设银行"
          },
            {
                value: "农业银行",
                label: "农业银行"
            },
          {
              value: "邮政储蓄银行",
              label: "邮政储蓄银行"
          },
          {
              value: "中国银行",
              label: "中国银行"
          },
          {
              value: "宁波银行",
              label: "宁波银行"
          },
          {
              value: "其他银行",
              label: "其他银行"
          }
      ],
        zjOptions: [
            {
                value: "法人",
                label: "法人"
            },
            {
                value: "经办人",
                label: "经办人"
            }
        ], zjlxOptions: [
            {
                value: "身份证",
                label: "身份证"
            },
            {
                value: "护照",
                label: "护照"
            }
        ], zflxOptions: [
            {
                value: "对公账号",
                label: "对公账号"
            },
            {
                value: "经营者账号",
                label: "经营者账号"
            }
        ],
        searchForm:{
            idcards_front: '',
            idcards_back: '',
            document_type:'',
            electronic_invoice:'否',
            holder_type: '',
            holder_name: '',
            identification_number: '',
            identification_start: '',
            identification_end: ''
        },
        form3:{
            business_img: '',
            business_number: '',
            business_scope: '',
            contractstdate: '',
            contractendate: '',
            business_license: '',
            prov_cd: '',
            city: '',
            areaid: ''
        },
        form4:{
            zflxtype: '',
            account_name: '',
            account_city: '',
            deposit_bank: '',
            bank_branch: '',
            bank_account: '',
            industry_license: '',
            wx_num_gf: '0.00',
            zfb_num_gf: '0.00',
            zfb_num_sxf: '0.00',
            wx_num_sxf: '0.00',
            zfb_num_fy: '0.00',
            wx_num_fy: '0.00'

        },
        form5:{
            organization_img: '',
            organization_code: '',
            organization_start: '',
            organization_end: ''
        }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
      dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
      UploadUrl:function(){
          return process.env.VUE_APP_API+"/moblieapp/currencyUpload";
      },
      agentOpen(data){
          if(data!=null && data!=""){
              this.oneagent=data;
              console.log("data.legal==="+data.legal);
              this.form.legal=data.legal;
              this.form.mobileNo=data.mobileNo;
              this.form.email=data.email;
              if(data.special_qualification!=null && data.special_qualification!="") {
                  this.fileList = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.special_qualification}]
                  this.form2.special_qualification = data.special_qualification;
              }
              this.form2.shortername=data.shortername;
              this.form2.agentname=data.agentname;
              this.form2.compaddress=data.compaddress;
              if(data.shop_scene!=null && data.shop_scene!="") {
                  console.log("data.shop_scene====="+data.shop_scene.split(","));
                  this.form2.shop_scene=data.shop_scene.split(",");
                 //this.$set(this.form2.shop_scene, data.shop_scene, [])
                // for (let key in data.shop_scene) {
                 // console.log("key====="+key);
                     // this.$set(this.form2.shop_scene, key, [])

                // }
              }
              this.form2.shop_tel=data.shop_tel;
              if(data.supple_materials!=null && data.supple_materials!="") {
                  this.form2.supple_materials = data.supple_materials;
                  this.fileList2 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.supple_materials}]
              }

              this.form3.business_number=data.business_number;
              this.form3.business_scope=data.business_scope;
              this.form3.contractstdate=data.contractstdate;
              this.form3.contractendate=data.contractendate;
              if(data.business_img!=null && data.business_img!="") {
                  this.form3.business_img = data.business_img;
                  this.fileList3 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.business_img}]
              }
              this.form3.business_license=data.business_license;
              this.form3.contractendate=data.contractendate;

              this.searchForm.holder_type=data.holder_type;
              this.searchForm.holder_name=data.holder_name;
              this.searchForm.document_type=data.document_type;
              this.searchForm.identification_number=data.identification_number;
              this.searchForm.identification_start=data.identification_start;
              this.searchForm.identification_end=data.identification_end;
              if(data.idcards_front!=null && data.idcards_front!="") {
                  this.searchForm.idcards_front = data.idcards_front;
                  this.fileList4 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.idcards_front}]
              }
              if(data.idcards_back!=null && data.idcards_back!=""){
                  this.searchForm.idcards_back=data.idcards_back;
                  this.fileList5 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/'+data.idcards_back}]
              }
              this.searchForm.electronic_invoice=data.electronic_invoice;

              this.form4.zflxtype=data.zflxtype;
              this.form4.account_name=data.account_name;
              this.form4.account_city=data.account_city;
              this.form4.deposit_bank=data.deposit_bank;
              this.form4.bank_branch=data.bank_branch;
              this.form4.bank_account=data.bank_account;
              if(data.industry_license!=null && data.industry_license!="") {
                  this.form4.industry_license = data.industry_license;
                  this.fileList6 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/'+data.industry_license}]
              }
              this.form4.wx_num_gf=data.wx_num_gf;
              this.form4.zfb_num_gf=data.zfb_num_gf;
              this.form4.zfb_num_sxf=data.zfb_num_sxf;
              this.form4.wx_num_sxf=data.wx_num_sxf;
              this.form4.zfb_num_fy=data.zfb_num_fy;
              this.form4.wx_num_fy=data.wx_num_fy;

              if(data.organization_img!=null && data.organization_img!="") {
                  this.form5.organization_img = data.organization_img;
                  this.fileList7 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/'+data.organization_img}]
              }
              this.form5.organization_code=data.organization_code;
              this.form5.organization_start=data.organization_start;
              this.form5.organization_end=data.organization_end;
          }
      },
    dialogOpen() {
        this.titlebt="录入资料("+this.agent.agentname+")";
        var formData2 = new FormData() // 声明一个FormData对象



        var formData3 = new FormData() // 声明一个FormData对象
        agentService.getProvcd(formData2).then(data => {
            this.typeOptions=data;
        });
        agentService.getShopsType(formData3).then(data => {
            this.shopOptions=data;
        });
        if(this.agent.city){
            this.currentSel(this.agent.prov_cd);
        }
        if(this.agent.areaid){
            this.currentSel2(this.agent.city);
        }
        if(this.agent.two_type){
            this.currentTypeSel(this.agent.one_type);
        }
        if(this.agent.three_type){
            this.currentTypeSel2(this.agent.two_type);
        }
        var formData4 = new FormData() // 声明一个FormData对象
        formData4.append("agentid",this.agent.agentid);
        agentService.getPerfectAgent(formData4).then(data => {
            this.agentOpen(data);
        });
        this.form3.prov_cd = this.agent.prov_cd;
        this.form3.city = this.agent.city;
        this.form3.areaid = this.agent.areaid;
        this.form2.one_type = this.agent.one_type;
        this.form2.two_type = this.agent.two_type;
        this.form2.three_type = this.agent.three_type;
    },
      handleClick(tab, event) {
          console.log(tab, event);

      },
      next() {
        if(this.active==0){
            this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.$refs["form2"].validate(valid => {
                            if (valid) {

                        agentService.saveAgentJjOne({ ...this.form, ...this.form2,userId:this.oneagent.userId,agentid:this.oneagent.agentid})
                            .then(data => {
                                this.agentOpen(data);
                                this.loading = false;
                                this.typeone = false;
                                this.typetwo = true;
                                this.typethree = false;
                                this.typefour = false;
                                this.tj = false;
                                this.isup = true;
                                this.xyb = true;
                                if(this.active<5){
                                    this.active++;

                                }

                            });
                            }else{
                                return false;
                            }
                        });

                    }else{
                        return false;
                    }
            });
        }else if(this.active==1){

            this.$refs["form3"].validate(valid => {
                if (valid) {
                    this.$refs["searchForm"].validate(valid => {
                        if (valid) {
                   agentService.saveAgentJjTwo({ ...this.form3, ...this.searchForm,userId:this.oneagent.userId,agentid:this.oneagent.agentid})
                        .then(data => {
                            this.agentOpen(data);
                            this.typeone=false;
                            this.typetwo=false;
                            this.typethree=true;
                            this.typefour=false;
                            this.tj=false;
                            this.isup=true;
                            this.xyb=true;
                            if(this.active<5){
                                this.active++;

                            }
                        });
                        }else{
                            return false;
                        }

                    });


                       // });

                }else{
                    return false;
                }
            });


          }else if(this.active==2){

            this.$refs["form4"].validate(valid => {
                if (valid) {
                    agentService.saveAgentJjThree({ ...this.form4,userId:this.oneagent.userId,agentid:this.oneagent.agentid})
                        .then(data => {
                            this.agentOpen(data);
                            this.typeone = false;
                            this.typetwo = false;
                            this.typethree = false;
                            this.typefour = true;
                            this.isup = true;
                            this.tj = false;
                            this.xyb = true;
                            if (this.active < 5) {
                                this.active++;

                            }
                        });
                }else{
                    return false;
                }
            })
        }else if(this.active==3){
            this.$refs["form5"].validate(valid => {
                if (valid) {
                    agentService.saveAgentJjFour({
                        ...this.form5,
                        userId: this.oneagent.userId,
                        agentid: this.oneagent.agentid
                    })
                        .then(data => {
                            this.agentOpen(data);
                            this.typeone = false;
                            this.typetwo = false;
                            this.typethree = false;
                            this.typefour = false;
                            this.isup = true;
                            this.xyb = false;
                            this.tj = true;
                            if (this.active < 5) {
                                this.active++;

                            }
                        });
                } else {
                    return false;
                }
            });

        }




      },
    del() {
        let msg = "审核";
        this.$confirm("确认"+msg+"操作？", "确认信息", {
            distinguishCancelAndClose: true,
            confirmButtonText: msg,
            cancelButtonText: "取消"
        }).then(() => {
            this.loading = true;
            agentService.delAgent({agentid:this.oneagent.agentid,type:2}).then(() => {
                this.loading = false;
                this.dialogVisible = false;
                this.$emit("submit");
            });
        });
    },
      currentSel(val) {
          if (this.agent.userId) {
              this.form.city = "";
              this.form.areaid = "";
          }
          this.typeOptions2=[];
          var formData2 = new FormData() // 声明一个FormData对象

          formData2.append('type','city')
          formData2.append('areaid',val)
          agentService.getProvcd(formData2).then(data => {
              this.typeOptions2=data;
          });
      },
      currentSel2(val) {
          this.typeOptions3=[];
          var formData2 = new FormData() // 声明一个FormData对象
          formData2.append('type','area')
          formData2.append('areaid',val)
          agentService.getProvcd(formData2).then(data => {
              this.typeOptions3=data;
          });
      },
      currentTypeSel(val) {
          if (this.agent.userId) {
              this.form.two_type = "";
              this.form.three_type = "";
          }
          this.shopOptions2=[];
          var formData2 = new FormData() // 声明一个FormData对象

          formData2.append('type','twotype')
          formData2.append('typeid',val)
          agentService.getShopsType(formData2).then(data => {
              this.shopOptions2=data;
          });
      },
      currentTypeSel2(val) {
          this.shopOptions3=[];
          var formData2 = new FormData() // 声明一个FormData对象
          formData2.append('type','threetype')
          formData2.append('typeid',val)
          agentService.getShopsType(formData2).then(data => {
              this.shopOptions3=data;
          });
      },
      upp() {
          console.log(this.active);
          if(this.active==1){
              this.typeone=true;
              this.typetwo=false;
              this.typethree=false;
              this.typefour=false;
              this.isup=false;
              this.tj=false;
              this.xyb=true;
          }else if(this.active==2){
              this.typeone=false;
              this.typetwo=true;
              this.typethree=false;
              this.typefour=false;
              this.isup=true;
              this.tj=false;
              this.xyb=true;
          }else if(this.active==3){
              this.typeone=false;
              this.typetwo=false;
              this.typethree=true;
              this.typefour=false;
              this.isup=true;
              this.tj=false;
              this.xyb=true;
          }else if(this.active==4){
              this.typeone=false;
              this.typetwo=false;
              this.typethree=false;
              this.typefour=true;
              this.isup=true;
              this.tj=false;
              this.xyb=true;
          }

          if(this.active>0){
              this.active--;

          }


      },
    // 上传文件之前的钩子
    handleBeforeUpload(file){
        let isJPG =true;
       // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
        console.log('before');
        if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
            isJPG=false;
            this.$notify.warning({
                title: '警告',
                message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
            })

        }
        let size = file.size / 1024 / 1024 / 2
        if(size > 2) {
            this.$notify.warning({
                title: '警告',
                message: '图片大小必须小于2M'
            })
            isJPG=false;
        }

        return isJPG // 返回false不会自动上传
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview(file) {
        console.log("=======file.url=========="+file.url);
        this.form3.business_img = file.url;
        this.dialogVisible = true;
    },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview2(file) {
          console.log("=======file.url=========="+file.url);
          this.searchForm.idcards_front = file.url;
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview3(file) {
          console.log("=======file.url=========="+file.url);
          this.searchForm.idcards_back = file.url;
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview4(file) {
          console.log("=======file.url=========="+file.url);
          this.form5.organization_img = file.url;
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview5(file) {
          console.log("=======file.url=========="+file.url);
          this.form2.special_qualification = file.url;
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview6(file) {
          console.log("=======file.url=========="+file.url);
          this.form2.supple_materials = file.url;
          this.dialogVisible = true;
      }, // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview7(file) {
          console.log("=======file.url=========="+file.url);
          this.form4.industry_license = file.url;
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handleRemove(file) {
          this.form3.business_img ="";
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handleRemove2(file) {
          this.searchForm.idcards_front = "";
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handleRemove3(file) {
          this.searchForm.idcards_back = "";
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handleRemove4(file) {
          this.form5.organization_img = "";
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handleRemove5(file) {
          this.form2.special_qualification = "";
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handleRemove6(file) {
          this.form2.supple_materials = "";
          this.dialogVisible = true;
      }, // 点击文件列表中已上传的文件时的钩子
      handleRemove7(file) {
          this.form4.industry_license = "";
          this.dialogVisible = true;
      },
    close() {
      this.dialogVisible = false;
    }
  }
};
</script>

